import React from 'react';
import PropTypes from 'prop-types';

import CiAlphaField from './CiAlpha/CiAlphaField';
import CiAlphaSlider from './CiAlpha/CiAlphaSlider';
import CutoffsFields from './CutoffsFields';
import ZScoreFields from './ZScoreFields';

import DistributionTypeDropdown from './DistributionTypeDropdown';
import NormalDistributionFields from './NormalDistributionFields';
import FisherDistributionFields from './FisherDistributionFields';
import StudentDistributionFields from './StudentDistributionFields';
import BinomialDistributionFields from './BinomialDistributionFields';

const DistributionFormComponent = props => (
  <form id="settings-form" className="height-full">
    <div className="content-item">
      <h2 className="header-page">
        Settings
      </h2>

      <DistributionTypeDropdown />

      {props.distributionType === 'normal' &&
        <NormalDistributionFields />
      }
      {props.distributionType === 'binomial' &&
        <BinomialDistributionFields />
      }
      {(props.distributionType === 'student' ||
        props.distributionType === 'chisquare') &&

        <StudentDistributionFields />
      }

      {props.distributionType === 'fisher' &&
        <FisherDistributionFields />
      }
      {!(props.distributionType === 'binomial') &&
        <>
          <p className="font-700 mb-0 mt-5">
            Probability
          </p>
          <CutoffsFields isInvalid={props.invalid} />
          <div className="flex-column ">
            <CiAlphaField />
            {props.distributionType === 'normal' &&
              <>
                <p className="font-700 mb-0">
                  Z-Score
                </p>
                <ZScoreFields isInvalid={props.invalid} />
              </>
            }
            <p className="font-700 mb-5">
              Shaded Area
            </p>
            <CiAlphaSlider />
          </div>
        </>
      }
    </div>
  </form>
);

DistributionFormComponent.propTypes = {
  distributionType: PropTypes.string.isRequired,
  invalid: PropTypes.bool
};

export default DistributionFormComponent;
